module.exports = __webpack_public_path__ + "img/collage_segmentation.2cfe4e4.svg";